import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { AccountInfo } from "../../components/organisms";
import { ILoginUser } from "../../services/api/customer";
import { IRootState } from "../../store/index";

interface IReduxProps {
  creditBalance?: number;
  isLoggedIn: boolean;
  user?: ILoginUser;
}

type RouteProps = RouteComponentProps;
type Props = IReduxProps & RouteProps & { dispatch: Dispatch<any> };

class AccountInfoContainer extends React.Component<Props> {
  /**
   * Render account info block
   */
  public render(): JSX.Element {
    return (
      <AccountInfo
        creditBalance={this.props.creditBalance}
        isLoggedIn={this.props.isLoggedIn}
        usersFields={this.props.user}
      />
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    creditBalance: state.checkoutState.creditBalance,
    isLoggedIn: state.userState.isLogedIn,
    user: state.userState.user,
  };
};

const store = withRouter(
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(
    AccountInfoContainer,
  ),
);

export { store as AccountInfoContainer };
